// extracted by mini-css-extract-plugin
export default {"l_AlertList_main":"AlertList_l_AlertList_main__AQFrb","l_AlertList_emptyDataContainer":"AlertList_l_AlertList_emptyDataContainer__7QEYe"};